// extracted by mini-css-extract-plugin
export var csatScore = "_ju-5";
export var header = "_ju-1";
export var panelWrapper = "_ju-2";
export var postPreview = "_ju-3";
export var rightContent = "_ju-0";
export var wrappingText = "_ju-4";